/* OPHIDRA 1.0.0 — Shopify-native cart, product and interface interactions */
(() => {
  'use strict';
  const cfg = window.OPHIDRA || {};
  const labels=cfg.labels||{};
  const root = (window.Shopify?.routes?.root || cfg.root || '/').replace(/\/?$/, '/');
  const $ = (q, el = document) => el.querySelector(q);
  const $$ = (q, el = document) => [...el.querySelectorAll(q)];
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function money(cents, currency = cfg.currency || 'USD') {
    const cur = String(currency || 'USD');
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:cur}).format(Number(cents || 0)/100); }
    catch { return (Number(cents || 0)/100).toFixed(2) + ' ' + cur; }
  }
  async function request(path, opts = {}) {
    const resp = await fetch(root + path, {credentials:'same-origin', ...opts});
    const json = await resp.json().catch(() => ({}));
    if (!resp.ok) throw new Error(json.description || json.message || `Shopify error ${resp.status}`);
    return json;
  }
  const drawer = $('#cart-drawer');
  if (document.querySelector('.main-cart [data-oph-gift-progress]')) request('cart.js').then(cart=>{const box=document.querySelector('.main-cart [data-oph-gift-progress]');if(!box)return;box.hidden=cart.currency!=='GBP';const remain=Math.max(0,6500-Math.max(0,Number(cart.total_price)||0));box.querySelector('[data-oph-gift-message]').textContent=remain?`Spend ${money(remain,cart.currency)} more to qualify for complimentary earrings.`:'£65 reached — your complimentary earrings are included at £0.00.';box.querySelector('[data-oph-gift-fill]').style.width=Math.min(100,Math.max(0,Number(cart.total_price)||0)/6500*100)+'%';}).catch(()=>{});
  const backdrop = $('[data-drawer-backdrop]');
  let lastFocused = null;
  let drawerRequestToken = 0;
  function openDrawer() {
    if (!drawer) return;
    lastFocused = document.activeElement;
    backdrop.hidden = false;
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    $('[data-drawer-close]', drawer)?.focus();
    refreshDrawer();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    backdrop.hidden = true;
    document.body.classList.remove('drawer-open');
    lastFocused?.focus?.();
  }
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', openDrawer));
  $('[data-drawer-close]')?.addEventListener('click', closeDrawer);
  backdrop?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeDrawer();
    if (event.key === 'Tab' && drawer?.classList.contains('open')) {
      const focusable = $$('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled)', drawer).filter(el => el.offsetParent !== null);
      if (!focusable.length) return;
      if (event.shiftKey && document.activeElement === focusable[0]) {focusable.at(-1).focus();event.preventDefault();}
      else if (!event.shiftKey && document.activeElement === focusable.at(-1)) {focusable[0].focus();event.preventDefault();}
    }
  });
  function buildLine(item, currency) {
    const img = item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="drawer-item-options">${escapeHTML(item.variant_title)}</p>` : '';
    const unit = `<span>${money(item.final_line_price, currency)}</span>`;
    const discount = item.original_line_price > item.final_line_price ? `<s>${money(item.original_line_price,currency)}</s>` : '';
    return `<div class="drawer-item" data-line-key="${escapeHTML(item.key)}">
      <a class="drawer-item-image" href="${escapeHTML(item.url)}">${img}</a>
      <div class="drawer-item-info">
        <a class="drawer-item-title" href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
        ${variant}
        <div class="drawer-item-price">${unit}${discount}</div>
        <div class="drawer-item-actions">
          <div class="drawer-item-quantity"><button type="button" data-line-change="-1" aria-label="${escapeHTML(labels.qtyDecrease || 'Decrease quantity')}">−</button><span>${item.quantity}</span><button type="button" data-line-change="1" aria-label="${escapeHTML(labels.qtyIncrease || 'Increase quantity')}">+</button></div>
          <button class="drawer-remove" data-line-remove type="button">${escapeHTML(labels.remove || 'Remove')}</button>
        </div>
      </div>
    </div>`;
  }
  function renderCart(cart) {
    const content = $('#cart-drawer-content');
    if (!content) return;
    const curr = cart.currency || cfg.currency || 'USD';
    const scrollArea = $('[data-op-cart-scroll]');
    const previousScroll = scrollArea ? scrollArea.scrollTop : 0;
    content.innerHTML = cart.items.length
      ? cart.items.map(item => buildLine(item, curr)).join('')
      : `<div class="drawer-empty"><p>${escapeHTML(labels.drawerEmpty || "Your bag is waiting for something distinctive.")}</p><a class="button button-dark" href="${escapeHTML(root + 'collections/all')}">${escapeHTML(labels.drawerShop || "Explore the collection ")}</a></div>`;
    $$('[data-cart-count]').forEach(el => el.textContent = String(cart.item_count));
    $('[data-cart-heading-count]')?.replaceChildren(document.createTextNode(`(${cart.item_count})`));
    const total = $('[data-cart-subtotal]');if (total) total.textContent = money(cart.total_price,curr);
    const discountRow = $('[data-op-cart-discount-row]');
    if (discountRow) {
      const saved = Math.max(0, Number(cart.total_discount)||0);
      discountRow.hidden = saved === 0;
      const value = $('[data-op-cart-discount-value]',discountRow);
      if(value) value.textContent = saved ? '−'+money(saved,curr) : '';
    }
    if (scrollArea && Math.abs(scrollArea.scrollTop - previousScroll) > 2) scrollArea.scrollTop = previousScroll;
    if (drawer?.classList.contains('open')) updateUpsell(cart);
    document.querySelectorAll('[data-oph-gift-progress]').forEach(box => {
      const eligible = curr === 'GBP';
      box.hidden = !eligible;
      if (!eligible) return;
      const remaining = Math.max(0, 6500 - Math.max(0,Number(cart.total_price)||0));
      const msg = box.querySelector('[data-oph-gift-message]');
      if (msg) msg.textContent = remaining > 0 ? `Spend ${money(remaining,curr)} more to qualify for complimentary earrings.` : '£65 reached — your complimentary earrings are included at £0.00.';
      const fill = box.querySelector('[data-oph-gift-fill]');
      if (fill) fill.style.width = `${Math.min(100,Math.max(0,Number(cart.total_price)||0)/6500*100)}%`;
      const reached = remaining === 0;
      if (reached && box.dataset.reached !== 'yes') {
        box.classList.remove('op-gift-celebrate');
        void box.offsetWidth;
        box.classList.add('op-gift-celebrate');
        window.setTimeout(() => box.classList.remove('op-gift-celebrate'), 1900);
      }
      box.dataset.reached = reached ? 'yes' : 'no';
    });
    const progress = $('[data-shipping-progress]');
    const threshold = Number(cfg.thresholds?.[curr] || 0);
    if (progress) {
      if (cfg.freeShippingEnabled && threshold > 0) {
        progress.hidden = false;
        const remaining = Math.max(0,Math.round(threshold*100)-cart.total_price);
        $('[data-shipping-text]',progress).textContent = remaining > 0 ? `${money(remaining,curr)} ${labels.shipLeft || "until the configured free-shipping threshold"}` : (labels.shipDone || "Free-shipping threshold reached — eligibility confirmed at checkout");
        $('[data-shipping-fill]',progress).style.width = Math.min(100,(cart.total_price / (threshold*100))*100) + '%';
      } else progress.hidden = true;
    }
  }
  document.addEventListener('oph:gift-updated',()=>{refreshDrawer();});
  // Multi-product cross-sell. Card prices come from the actual Shopify product API.
  // Skip items already in the bag; ensure the recommended variant is purchasable.
  let upsellToken = 0;
  async function updateUpsell(cart) {
    const box = $('[data-op-cart-upsell]');
    const list = $('[data-op-upsell-list]');
    if (!box || !list) return;
    const token = ++upsellToken;
    if (!cart.items.length) { box.hidden = true; list.replaceChildren(); return; }
    try {
      const response = await request('collections/necklaces/products.json?limit=50');
      if (token !== upsellToken) return;
      const inBag = new Set(cart.items.map(item => String(item.product_id)));
      const eligible = (response.products || []).filter(product => {
        if (inBag.has(String(product.id)) || product.handle === 'the-serpent-necklace') return false;
        return (product.variants || []).some(variant => variant.available);
      });
      const suggestions = eligible.slice(0, 5);
      if (!suggestions.length) {box.hidden = true; list.replaceChildren(); return;}
      const currency = cart.currency || cfg.currency || 'GBP';
      list.innerHTML = suggestions.map(product => {
        const variant = product.variants.find(v => v.available);
        const price = Number(variant.price);
        const img = product.images?.[0]?.src || product.image?.src;
        const picture = img ? `<img src="${escapeHTML(img)}" alt="${escapeHTML(product.title)}" loading="lazy">` : `<span class="op-upsell-placeholder" aria-hidden="true">✧</span>`;
        return `<article class="op-cart-upsell-item">
          <a class="op-upsell-picture" href="${escapeHTML(root + 'products/' + product.handle)}">${picture}</a>
          <div class="op-upsell-details">
            <a class="op-upsell-name" href="${escapeHTML(root + 'products/' + product.handle)}">${escapeHTML(product.title)}</a>
            <span class="op-upsell-price">${money(Number.isFinite(price) ? Math.round(price * 100) : 0, currency)}</span>
            <button type="button" class="op-cart-upsell-add" data-op-upsell-add data-variant-id="${escapeHTML(variant.id)}" aria-label="Add ${escapeHTML(product.title)} to shopping bag">Add +</button>
          </div>
        </article>`;
      }).join('');
      box.hidden = false;
    } catch(error) { if (token === upsellToken) {box.hidden = true; list.replaceChildren();} }
  }
  $('[data-op-cart-upsell]')?.addEventListener('click', async event => {
    const button = event.target.closest('[data-op-upsell-add]');
    if (!button || button.disabled) return;
    const id = Number(button.dataset.variantId);
    if (!Number.isSafeInteger(id) || id <= 0) return;
    const error = $('[data-op-upsell-error]');
    if (error) error.textContent = '';
    button.disabled = true;
    try {
      await request('cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:1})});
      await refreshDrawer();document.dispatchEvent(new Event('oph:cart-updated'));
    } catch(err) { if (error) error.textContent = err.message; }
    finally { button.disabled = false; }
  });
  async function refreshDrawer() {
    const token = ++drawerRequestToken;
    try { const cart = await request('cart.js'); if (token === drawerRequestToken) renderCart(cart); }
    catch(error){const content = $('#cart-drawer-content');if(content)content.innerHTML = `<p class="drawer-error">${escapeHTML(labels.drawerError || "Unable to load the bag.")} ${escapeHTML(error.message)}</p>`;}
  }
  // A £5 promotional code can remain attached to a shopper's cart between visits.
  // Show an explicit way to remove it; never silently override legitimate discounts.
  drawer?.addEventListener('click', async event => {
    const removeDiscount = event.target.closest('[data-op-clear-discount]');
    if (!removeDiscount) return;
    removeDiscount.disabled = true;
    try {
      await request('cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:''})});
      await refreshDrawer();
      document.dispatchEvent(new Event('oph:cart-updated'));
    } catch (error) {
      removeDiscount.disabled = false;
      const note = document.createElement('span'); note.className = 'drawer-error'; note.textContent = error.message;
      removeDiscount.parentElement.append(note);
    }
  });
  drawer?.addEventListener('click', async event => {
    const button = event.target.closest('[data-line-change],[data-line-remove]');
    if (!button) return;
    const row = button.closest('[data-line-key]');
    if (!row) return;
    const key = row.dataset.lineKey;
    const count = Number(row.querySelector('.drawer-item-quantity span').textContent);
    const quantity = button.hasAttribute('data-line-remove') ? 0 : Math.max(0,count + Number(button.dataset.lineChange));
    button.disabled = true;
    try { const cart = await request('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity})});renderCart(cart);document.dispatchEvent(new Event('oph:cart-updated')); }
    catch(error) {button.disabled=false;const err=document.createElement('div');err.className='drawer-error';err.textContent=error.message;row.append(err);}
  });
  const menuToggle = $('[data-mobile-menu-toggle]');
  const mobileNav = $('#mobile-navigation');
  menuToggle?.addEventListener('click',() => {
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));
    mobileNav.hidden = expanded;
  });
  function setupProduct(rootElement) {
    const variantJSON = $('[data-product-variants]', rootElement);
    if (!variantJSON) return;
    let variants;
    try {variants = JSON.parse(variantJSON.textContent)} catch {return;}
    if (!variants?.length) return;
    const byId = new Map(variants.map(v => [String(v.id),v]));
    const productForm = $('form.product-form',rootElement);
    const hiddenID = $('[data-form-variant-id]',rootElement);
    const selectedButton = $('[data-variant-button].active',rootElement);
    let active = byId.get(selectedButton?.dataset.variantButton) || byId.get(hiddenID?.value) || variants[0];
    let quantity = 1;
    const selectsArea = $('[data-bundle-variants]',rootElement);
    const firstSelect = $('[data-bundle-select]',selectsArea);
    const addButton = $('[data-add-to-cart]',rootElement);
    const stickyButton = $('[data-sticky-add]');
    const moneyCurrency = cfg.currency || 'USD';
    const mediaList = $$('[data-media-id][data-media-index]',rootElement);
    const thumbList = $$('[data-media-thumb]',rootElement);
    const zoomDialog = $('[data-product-zoom-dialog]') || $('[data-product-zoom-dialog]',document);
    let activeMedia = 0;
    function setMedia(index) {
      if (!mediaList.length) return;
      activeMedia = Math.min(Math.max(index,0),mediaList.length-1);
      mediaList.forEach((media,i) => {media.hidden=i!==activeMedia;media.classList.toggle('is-active',i===activeMedia);if(i!==activeMedia)$$('video',media).forEach(v=>v.pause());});
      thumbList.forEach(b=>{const yes=b.dataset.mediaThumb===mediaList[activeMedia].dataset.mediaId;b.classList.toggle('active',yes);b.setAttribute('aria-current',String(yes));});
    }
    thumbList.forEach(button=>button.addEventListener('click',()=>setMedia(mediaList.findIndex(m=>m.dataset.mediaId===button.dataset.mediaThumb))));
    let startX=0;
    const gallery=$('[data-product-gallery]',rootElement);
    gallery?.addEventListener('touchstart',e=>{startX=e.touches[0]?.clientX || 0},{passive:true});
    gallery?.addEventListener('touchend',e=>{const end=e.changedTouches[0]?.clientX || 0;if(Math.abs(end-startX)>45)setMedia(activeMedia + (end<startX?1:-1));},{passive:true});
    rootElement.querySelectorAll('[data-media-zoom]').forEach(trigger=>trigger.addEventListener('click',()=>{
      if(!zoomDialog?.showModal)return;
      const image=$('img',trigger);if(!image)return;
      const large=$('[data-zoom-image]',zoomDialog);large.src=image.currentSrc || image.src;large.alt=image.alt;zoomDialog.showModal();
    }));
    $('[data-zoom-close]',zoomDialog)?.addEventListener('click',()=>zoomDialog.close());
    zoomDialog?.addEventListener('click',ev=>{if(ev.target===zoomDialog)zoomDialog.close();});
    function availableVariants(){return variants.filter(v=>v.available)}
    function selectHTML(n) {
      const selected = n===0 ? active.id : (availableVariants()[0]?.id || active.id);
      return `<div class="bundle-variant-row"><div class="bundle-piece-head"><span class="piece-number">${String(n+1).padStart(2,'0')}</span><label for="bundle-slot-${n}-${rootElement.dataset.sectionId}">Piece ${n+1} <small>Choose your print / size</small></label></div><select id="bundle-slot-${n}-${rootElement.dataset.sectionId}" data-bundle-select aria-label="Print and size for piece ${n+1}">${variants.map(v=>`<option value="${v.id}"${v.id===selected?' selected':''}${!v.available?' disabled':''}>${escapeHTML(v.title)}</option>`).join('')}</select></div>`;
    }
    function currentItems() {
      const counts = new Map();
      $$('[data-bundle-select]',selectsArea).forEach(sel=>{const k=sel.value;counts.set(k,(counts.get(k)||0)+1)});
      return [...counts.entries()].map(([id,quantity])=>({id:Number(id),quantity}));
    }
    function totalUpdate() {
      const total = $$('[data-bundle-select]',selectsArea).reduce((sum,sel)=>sum+(byId.get(sel.value)?.price || 0),0);
      const discount=0;
      const savings=quantity===3?Math.min(...$$('[data-bundle-select]',selectsArea).map(sel=>byId.get(sel.value)?.price||0)):0;const preview=total-savings;
      const elem=$('[data-bundle-total]',rootElement);if(elem)elem.textContent=money(preview,moneyCurrency);
      const original=$('[data-bundle-original]',rootElement);if(original)original.textContent=money(total,moneyCurrency);
      const saved=$('[data-bundle-savings]',rootElement);if(saved)saved.textContent=savings?'-'+money(savings,moneyCurrency):'—';
    }
    function renderQuantity() {
      const prev = $$('[data-bundle-select]',selectsArea).map(sel=>sel.value);
      const markup=Array.from({length:quantity},(_,i)=>selectHTML(i)).join('');
      selectsArea.innerHTML=markup;
      $$('[data-bundle-select]',selectsArea).forEach((sel,i)=>{
        if(i<prev.length && byId.get(prev[i])?.available)sel.value=prev[i];
        else if(i===0 && active.available)sel.value=String(active.id);
        sel.addEventListener('change',totalUpdate);
      });
      $$('[data-bundle-radio]',rootElement).forEach(r=>r.closest('.bundle-choice')?.classList.toggle('active',Number(r.value)===quantity));
      totalUpdate();
    }
    function updateVariant(v) {
      active=v;
      if(hiddenID)hiddenID.value=v.id;
      $$('[data-variant-button]',rootElement).forEach(btn=>{const yes=btn.dataset.variantButton===String(v.id);btn.classList.toggle('active',yes);btn.setAttribute('aria-pressed',String(yes));});
      const name=$('[data-variant-name]',rootElement);if(name)name.textContent='— '+v.title;
      const price=$('[data-product-price]',rootElement);if(price)price.textContent=money(v.price,moneyCurrency);
      const sticky=$('[data-sticky-price]');if(sticky)sticky.textContent=money(v.price,moneyCurrency);
      const compare=$('[data-compare-price]',rootElement);const discount=$('[data-price-discount]',rootElement);
      const discounted=v.compare_at_price && v.compare_at_price>v.price;
      if(compare){compare.hidden=!discounted;if(discounted)compare.textContent=money(v.compare_at_price,moneyCurrency)}
      if(discount){discount.hidden=!discounted;if(discounted)discount.textContent='Save '+Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)+'%'}
      if(addButton){addButton.disabled=!v.available;const label=$('[data-add-button-text]',rootElement);if(label)label.textContent=v.available?'Add to bag':'Out of stock';}
      if(stickyButton){stickyButton.disabled=!v.available;stickyButton.textContent=v.available?'Add to bag ':'Out of stock';}
      const sels=$$('[data-bundle-select]',selectsArea);if(sels[0])sels[0].value=String(v.id);
      totalUpdate();
      const mediaID=$(`[data-map-variant="${v.id}"]`,rootElement)?.dataset.mapMedia;
      const index=mediaList.findIndex(m=>m.dataset.mediaId===mediaID);
      if(index>=0)setMedia(index);
      const url=new URL(window.location.href);url.searchParams.set('variant',String(v.id));history.replaceState(null,'',url);
    }
    $$('[data-variant-button]',rootElement).forEach(btn=>btn.addEventListener('click',()=>{const v=byId.get(btn.dataset.variantButton);if(v)updateVariant(v)}));
    $$('[data-bundle-radio]',rootElement).forEach(r=>r.addEventListener('change',()=>{quantity=Number(r.value);renderQuantity()}));
    async function addToCart() {
      const error=$('[data-product-error]',rootElement);if(error)error.textContent='';
      const items=currentItems();
      if(!items.length || items.some(item=>!byId.get(String(item.id))?.available)) {if(error)error.textContent='Please choose available variants for every piece.';return;}
      if(addButton)addButton.disabled=true;
      if(stickyButton)stickyButton.disabled=true;
      const label=$('[data-add-button-text]',rootElement);if(label)label.textContent='Adding…';
      try {
        await request('cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        if(label)label.textContent='Added to bag';
        openDrawer();
      } catch(e){if(error)error.textContent=e.message;}
      finally {if(addButton)addButton.disabled=!active.available;if(stickyButton)stickyButton.disabled=!active.available;if(label)label.textContent=active.available?'Add to bag':'Out of stock';}
    }
    productForm?.addEventListener('submit',event=>{event.preventDefault();addToCart()});
    stickyButton?.addEventListener('click',addToCart);
    renderQuantity();
    updateVariant(active);
  }
  $$('[data-product-root]').forEach(setupProduct);
  // Keep cart badge accurate when a customer returns to the storefront.
  request('cart.js').then(cart=>{$$('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count))}).catch(()=>{});
})();
